import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useStickyControls } from '@/hooks/useStickyControls';
import { DetailStickyControlsProvider } from '../../-hooks/useDetailStickyControls';

export const Route = createFileRoute('/(client)/capa/(pages)/(detail)')({
  component: DetailLayout,
});

function DetailLayout() {
  // Condensed control strip (Submit Remediation/Request Changes/Mark as
  // Done) once the header scrolls past — see `CapaDetailHeader`.
  const stickyControls = useStickyControls('--capa-header-h');

  // The single scroll container for every CAPA detail page. Fills the flex
  // column the client layout provides (`h-full flex flex-col`) rather than
  // hardcoding a `100vh - header` calc: that guessed the header height wrong
  // (it is 52px, not 58px) and was duplicated by a second identical wrapper in
  // each page component, so the two nested containers fought over the scroll.
  //
  // Deliberately NOT `flex flex-col` — flex children default to `shrink: 1`, so
  // a tall page would be squeezed to fit the container and clipped instead of
  // overflowing into a scroll. Block children stack at their natural height.
  // `data-detail-body` marks this as a detail surface so descendant `.text-xs`
  // follows the platform's 12→14px step at 1600px, the same as the finding and
  // action sheets. The full-page CAPA detail routes were never marked, which is
  // why their `text-xs` content read smaller than their `text-sm` content.
  return (
    <div
      ref={stickyControls.scrollRef}
      data-detail-body
      className='flex-1 min-h-0 overflow-y-auto'
    >
      <DetailStickyControlsProvider value={stickyControls}>
        <Outlet />
      </DetailStickyControlsProvider>
    </div>
  );
}
